// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const integrations = [
  Sentry.replayIntegration({
    maskAllText: process.env.NEXT_PUBLIC_ENV === 'PROD',
    blockAllMedia: process.env.NEXT_PUBLIC_ENV === 'PROD',
    networkDetailAllowUrls: [/.*?/],
    networkRequestHeaders: ['*'],
    networkResponseHeaders: ['*'],
  }),
];

Sentry.init({
  dsn: 'https://e301caf32d6f48d5d97bd1ce6e525ece@sentry.alienplatform.com/7',

  // Add optional integrations for additional features
  integrations,

  environment: process.env.NEXT_PUBLIC_ENV,
  enabled: process.env.NEXT_PUBLIC_ENV !== 'DEV',

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.3,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
